// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const SectionBody = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
`;
